import PropTypes from 'prop-types'

const TableTwo = (props: any) => {
    return (
        <ul className='table-two'>
            {props.elements.map((item: any, i: number) => (
                <li key={i}>
                    <span> {item.left} </span>
                    <span> {item.right} </span>
                </li>
            ))}
        </ul>
    )
}

export default TableTwo

TableTwo.propTypes = {
    elements: PropTypes.array.isRequired
}
